export default __webpack_public_path__ + "static/media/05.bf458f15.jpg";